function importAll(r) {
  return r.keys().map((fileName, index) => {
    const name = fileName
      .replace("./", "")
      .split(".")[0]
      .replace(/[-_]/g, " ");

    // Random ETH price between 0.01 and 0.05
    const priceETH = (Math.random() * 0.04 + 0.01).toFixed(3);
    const priceUSD = (priceETH * 1850).toFixed(2); // Convert to USD

    return {
      id: index + 1,
      name,
      artist: "Unknown Artist",
      priceETH: `${priceETH} ETH`,
      priceUSD: `$${priceUSD} USD`,
      image: r(fileName),
    };
  });
}

const nftData = importAll(
  require.context("../assets/nfts", false, /\.(png|jpe?g|gif|avif|webp)$/)
);

export default nftData;
